import * as React from 'react';

var _path, _path2, _path3, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgInstagram = function SvgInstagram(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_1607_4736)",
        d: "M60.137 0h-.274C26.802 0 0 26.802 0 59.863v.274C0 93.198 26.802 120 59.863 120h.274C93.198 120 120 93.198 120 60.137v-.274C120 26.802 93.198 0 60.137 0"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M78.568 24.414H41.437c-10.259 0-18.604 8.345-18.604 18.603v33.97c0 10.258 8.345 18.604 18.604 18.604h37.13c10.26 0 18.604-8.346 18.604-18.604v-33.97c0-10.258-8.345-18.603-18.603-18.603M29.396 43.017c0-6.638 5.402-12.04 12.04-12.04h37.132c6.638 0 12.04 5.402 12.04 12.04v33.97c0 6.638-5.402 12.04-12.04 12.04H41.437c-6.639 0-12.041-5.402-12.041-12.04z"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M60.003 77.302c9.539 0 17.304-7.76 17.304-17.304s-7.76-17.304-17.304-17.304-17.305 7.76-17.305 17.304 7.761 17.304 17.305 17.304m0-28.042c5.923 0 10.741 4.818 10.741 10.742s-4.818 10.742-10.741 10.742c-5.924 0-10.742-4.818-10.742-10.742S54.079 49.26 60.003 49.26M78.909 45.49a4.67 4.67 0 0 0 4.662-4.663 4.665 4.665 0 0 0-4.662-4.663 4.665 4.665 0 0 0-4.663 4.663 4.665 4.665 0 0 0 4.663 4.662"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1607_4736",
        x1: 17.531,
        x2: 102.469,
        y1: 102.469,
        y2: 17.536,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FAAD4F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.35,
        stopColor: "#DD2A7B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.62,
        stopColor: "#9537B0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#515BD4"
    })))));
};

export { SvgInstagram as ReactComponent };
//# sourceMappingURL=Instagram.svg.es.js.map
